export default __webpack_public_path__ + "static/media/img3.758f68ab.jpg";